import { createApp } from 'vue';
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.less';
import './assets/css/custom-theme.css';
import './assets/css/page-cutom-components.css';
import './assets/css/base.css';
import App from './App.vue';
import router from './router';
import store from './store';
import { drag } from '@/utils/base/drag';
import tableLayout from '@/layout/components/table.vue';
import Vconsole from 'vconsole'

const app = createApp(App);

app.directive('drag', drag);

app.component('tableLayout', tableLayout);

// 小于1024载入vconsole
if (window.screen.width < 1024 && process.env.NODE_ENV !== 'production') {
    const vConsole: any = new Vconsole()
    app.use(vConsole);
}
app.use(Antd);
app.use(store);
app.use(router);
app.mount('#app');

